// extracted by mini-css-extract-plugin
export var quillEditor = "_n8-1";
export var variable = "_n8-0";